/**
 * Очередь отложенных действий уведомлений (FSD: shared не импортирует features).
 * Обработчик задаётся из features/notifications при старте приложения.
 */
export type QueuedNotificationActionHandler = (data: unknown) => Promise<void>

let handler: QueuedNotificationActionHandler | undefined

export function setQueuedNotificationActionHandler(
  fn: QueuedNotificationActionHandler | undefined,
): void {
  handler = fn
}

export async function invokeQueuedNotificationAction(data: unknown): Promise<void> {
  if (!handler) return
  await handler(data)
}
